var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C4 20.4477 4.44772 20 5 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4118 3.17352C13.9739 1.61143 16.5066 1.61143 18.0687 3.17352L18.826 3.93088C20.3881 5.49298 20.3881 8.02564 18.826 9.58774L11.9199 16.4938C11.6425 16.7712 11.2896 16.9609 10.9051 17.0393L6.40157 17.9572C4.99701 18.2435 3.75618 17.0027 4.04242 15.5981L4.96022 11.0944C5.03857 10.7099 5.22828 10.357 5.50573 10.0796L12.4118 3.17352ZM16.6545 4.58774C15.8734 3.80669 14.6071 3.80669 13.826 4.58773L13.4144 4.99938L17.0002 8.58516L17.4118 8.17353C18.1929 7.39248 18.1929 6.12614 17.4118 5.34509L16.6545 4.58774ZM8.41437 9.99936L12.0002 6.41359L15.586 9.99937L12.0002 13.5852L8.41437 9.99936ZM7.00015 11.4136L6.91994 11.4938L6.00214 15.9975L10.5057 15.0796L10.5859 14.9994L7.00015 11.4136Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.652824c677b09a1553a92756479eda9d.svg";
export { ForwardRef as ReactComponent };